import React from "react";
import usePixModalStyles from "../PixPaymentModal.styles";
import { PixValueSectionProps } from "../types";

const formatAmount = (value: number) => {
  const parts = value
    .toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    .split(",");
  return { integer: parts[0], decimals: parts[1] };
};

const PixValueSection: React.FC<PixValueSectionProps> = ({ amount }) => {
  const classes = usePixModalStyles();
  const { integer, decimals } = formatAmount(amount);

  return (
    <div className={classes.valueSection}>
      <div className={classes.valueLabel}>VALOR A PAGAR</div>
      <div className={classes.valueAmount}>
        <span className={classes.valueCurrency}>R$</span> {integer}
        <span className={classes.valueDecimals}>,{decimals}</span>
      </div>

      <div className={classes.instructions}>
        <div className={classes.instructionItem}>
          <span
            className={`${classes.instructionNum} ${classes.instructionNumPending}`}
          >
            1
          </span>
          <span>
            O QR Code é atualizado automaticamente caso o valor do pedido sofra
            alteração.
          </span>
        </div>
        <div className={classes.instructionItem}>
          <span
            className={`${classes.instructionNum} ${classes.instructionNumPending}`}
          >
            2
          </span>
          <span>
            A liberação do pedido ocorre somente após a confirmação do pagamento
            pela instituição financeira.
          </span>
        </div>
        <div className={classes.instructionItem}>
          <span
            className={`${classes.instructionNum} ${classes.instructionNumPending}`}
          >
            3
          </span>
          <span>
            Realize o pagamento exclusivamente pelo QR Code gerado neste portal
            para evitar atrasos.
          </span>
        </div>
      </div>
    </div>
  );
};

export default PixValueSection;
